/**
 * Application route path builders — single source of truth.
 * Import these instead of hard-coding route strings.
 */

/** Canonical public detail page for any activity (event, excursion, course). */
export const activityDetailPath = (id: string) => `/event/${id}`;

/** Admin producer detail page (canonical plural root). */
export const adminProducerPath = (producerId: string) =>
  `/app/admin/producers/${producerId}`;

/** Public producer page route. */
export const producerPublicPath = (slugOrId: string) =>
  `/producer/${slugOrId}`;

/** Public producer activities embed route (iframe widget v1). */
export const producerActivitiesEmbedPath = (producerSlug: string) =>
  `/embed/producer/${producerSlug}`;

/** Public single activity embed route (iframe widget v1). */
export const activityEmbedPath = (activityId: string) =>
  `/embed/activity/${activityId}`;

/** Public single product embed route (iframe widget v1). */
export const productEmbedPath = (productId: string) =>
  `/embed/product/${productId}`;

/** Public producer shop route. */
export const producerShopPath = (slugOrId: string) =>
  `${producerPublicPath(slugOrId)}/shop`;

/** Public producer product detail route. */
export const producerProductPath = (slugOrId: string, productSlugOrId: string) =>
  `${producerShopPath(slugOrId)}/${productSlugOrId}`;
